import { useSearchParams, Navigate } from 'react-router-dom';
import { ResetPasswordForm } from '../../components/auth';
import { AuthLayout } from '../../components/layouts';

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <AuthLayout title="Set new password">
      <ResetPasswordForm token={token} />
    </AuthLayout>
  );
}
